import React from 'react'

export const ShieldIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="40" height="40" rx="3" fill="white" />
		<path
			d="M28 13.3601V18.3559C28 25.9732 20.4167 28.9297 20.4167 28.9297L20 29.1L19.5833 28.9297C19.5833 28.9297 12 25.9732 12 18.3559V13.3601C12 12.9994 12.1405 12.6534 12.3905 12.3984C12.6406 12.1433 12.9797 12 13.3333 12H26.6667C27.0203 12 27.3594 12.1433 27.6095 12.3984C27.8595 12.6534 28 12.9994 28 13.3601Z"
			fill="#545563"
		/>
		<path
			d="M28.0013 18.3559V13.3601C28.0013 12.9994 27.8608 12.6534 27.6108 12.3984C27.3607 12.1433 27.0216 12 26.668 12H20.418V28.9297C21.683 28.5004 28.0013 25.9732 28.0013 18.3559Z"
			fill="#85ADFF"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.0624 20.9668L23.5091 16.1578C23.8958 15.7396 24.5494 15.717 24.964 16.1076C25.3732 16.4931 25.3954 17.1363 25.0137 17.5491L19.6278 23.3739C19.3229 23.7036 18.8018 23.7036 18.4969 23.3739L16.0583 20.7366C15.6767 20.3238 15.6989 19.6806 16.1081 19.2951C16.5227 18.9045 17.1763 18.9271 17.563 19.3453L19.0624 20.9668Z"
			fill="white"
		/>
	</svg>
)
